import { ArrowDownOutlined, CheckOutlined, ArrowUpOutlined } from '@ant-design/icons'
import { useFormatter } from '@api/useFormatter'
import { DirectiveGrouping } from '@components/_SiteWide/OrderDisplay/DirectiveGrouping'
import {
  addCommasToNumber,
  BBDTag,
  CheckCard,
  NumberCell,
  SingleDateCell,
  TagCell,
  TextCell,
} from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import React from 'react'

function SupplyPriceTagCR({ data }) {
  const { formatCurrency } = useFormatter()
  const formattedPrice = formatCurrency(parseFloat(data.price), true, 4)

  if (!data) return null
  const deltaToLow = data.delta_to_low
  if (deltaToLow == null) return <TagCell value={`${formattedPrice} (Old)`} tagTheme={{ warning: true }} />
  if (deltaToLow > 0)
    return (
      <TagCell
        value={`${formattedPrice} (+${deltaToLow.toFixed(4)})`}
        tagTheme={{ error: true }}
        textWeight='bold'
        textAppearance='error'
      />
    )
  return <TagCell value={`${price} (Low)`} tagTheme={{ success: true }} textWeight='bold' textAppearance='success' />
}

function StatusCR({ data, as_of }) {
  if (!data) return null

  return <DirectivePopover value={data.status} row={data} as_of={as_of} />
}

function DirectivePopover({ value, row, as_of }) {
  if (!row.group_id) return <SupplyStatusTag value={value} row={row} />
  return (
    <Popover
      trigger='click'
      styles={{ body: { padding: 0 } }}
      content={<DirectiveGrouping as_of={as_of} row={row} />}
      placement='leftTop'
    >
      <div>
        <SupplyStatusTag value={value} row={row} />
      </div>
    </Popover>
  )
}

function SupplyStatusTag({ value, row }) {
  if (!value) {
    return <BBDTag>N/A</BBDTag>
  }
  if (value.toLowerCase() === 'under') {
    return (
      <BBDTag error icon={<ArrowDownOutlined />}>
        {row.status_value && `${addCommasToNumber(parseInt(row.status_value))}  ${value}`}
      </BBDTag>
    )
  }
  if (value.toLowerCase() === 'over') {
    return (
      <BBDTag error icon={<ArrowUpOutlined />}>
        {row.status_value && `${addCommasToNumber(parseInt(row.status_value))}  ${value}`}
      </BBDTag>
    )
  }
  return (
    <BBDTag success icon={<CheckOutlined />}>
      {value}
    </BBDTag>
  )
}

export const supplyReportCR = {
  textCell: TextCell,
  tagCell: TagCell,
  numberCell: NumberCell,
  singleDateCell: SingleDateCell,
  supplyPriceTagCR: SupplyPriceTagCR,
  statusCR: StatusCR,
}
